import { createSelector } from '@reduxjs/toolkit';

import { RootState } from 'types';
import { initialState } from '.';

const selectSlice = (state: RootState) => state.targetList || initialState;

export const selectTargetList = createSelector([selectSlice], state => state);
